import { useCallback, useMemo, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { isFileAnAudio } from 'hb-react/shared/utils/files/fileContentTypes';

import CategoriesList from '../CategoriesList';

const VideoPlayer = ({
  url,
  categories,
  networkCategoryIds,
  downloadable,
  fileType,
}) => {
  const location = useLocation();
  const videoRef = useRef();
  const [currentTime, setCurrentTime] = useState();
  const [isError, setIsError] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const playing = searchParams.has('play') || location?.state?.play;

  const onError = useCallback(() => {
    setCurrentTime(videoRef.current.getCurrentTime());
    setIsError(true);
  }, []);

  const onReady = useCallback(() => {
    if (isError) {
      videoRef.current.seekTo(currentTime);
      setIsError(false);
    }
  }, [currentTime, isError]);

  const playerProps = useMemo(() => {
    const isAudio = isFileAnAudio(fileType);

    return {
      ref: videoRef,
      url,
      controls: true,
      playing,
      width: isAudio ? '300px' : '100%',
      height: isAudio ? '50px' : '100%',
      style: {
        maxWidth: '100%',
        maxHeight: isAudio ? '50px' : '100%',
      },
      onError,
      onReady,
      ...(downloadable
        ? {}
        : {
            config: { file: { attributes: { controlsList: 'nodownload' } } },
          }),
    };
  }, [url, fileType, downloadable, playing, onError, onReady]);

  return (
    <VideoContentWrapper data-testid="video-audio-preview">
      <ReactPlayer {...playerProps} />
      <CategoriesList
        categories={categories}
        networkCategoryIds={networkCategoryIds}
      />
    </VideoContentWrapper>
  );
};

export default VideoPlayer;

const VideoContentWrapper = styled(Box).attrs({
  display: 'flex',
  maxWidth: '100%',
  maxHeight: '100%',
  height: '100%',
  width: '100%',
  alignItems: 'center',
  margin: 'auto',
  flexDirection: 'column',
  justifyContent: 'center',
})``;
